import { Utility } from "../../../../../common/utility";

export class StandardHeaderAction {
    public actionJSON: any = {};
    private utility: Utility;

    constructor(actionObject: any) {
        this.utility = new Utility();
        this.formActionJSON(actionObject);
    }


    formActionJSON(actionObject: any) {
        if (actionObject.isRuleApplied) {
            if (actionObject.isVisible === 'true') {
                this.actionJSON = {
                    headerFormRules: {
                        [actionObject.name]: {
                            fields: actionObject.visibilityRuleFields,
                            visible: actionObject.visibilityRuleObj.visible
                        }
                    }
                }
            } else {
                this.actionJSON = {
                    headerFormRules: {
                        [actionObject.name]: {
                            fields: [],
                            visible: actionObject.visibilityRuleObj.visible
                        }
                    }
                }
            }
            if(actionObject.componentName){
                const compName = this.utility.toKebabStyle(actionObject.componentName);
                if (actionObject.hasOwnProperty('isBulkChecked')) {
                    this.actionJSON = { ...this.actionJSON,
                        headerActions: {
                            name: actionObject.name,
                            label: actionObject.label,
                            bulk: actionObject.isBulkChecked,
                            componentName: compName
                        }
                    }
                } else {
                    this.actionJSON = { ...this.actionJSON,
                        headerActions: {
                            name: actionObject.name,
                            label: actionObject.label,
                            componentName: compName
                        }
                    }
                }
            }
        } else {
            const compName = this.utility.toKebabStyle(actionObject.componentName);
            if (actionObject.hasOwnProperty('isBulkChecked')) {
                this.actionJSON = {
                    headerActions: {
                        name: actionObject.name,
                        label: actionObject.label,
                        bulk: actionObject.isBulkChecked,
                        componentName: compName
                    }
                }
            } else {
                this.actionJSON = {
                    headerActions: {
                        name: actionObject.name,
                        label: actionObject.label,
                        componentName: compName
                    }
                }
            }

        }
        return this.actionJSON;
    }


}